export enum BadgeValues {
    All = 1,
    SMSOnly,
    EmailOnly
}
